import { observer } from 'mobx-react-lite';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useParams  } from 'react-router-dom';
import { Container, Header, Segment, Button, Message, Image } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import AgreementForm from '../residents/AgreementForm';
import InvalidResident from '../errors/InvalidResident';
import LoadingComponent from '../../app/layout/LoadingComponent';
import ParseHtml from 'html-react-parser';
import BhpLogo from '../../app/img/BHP_white_logo.png';

export default observer(function HomePage() {

    const {residentStore, modalStore } = useStore();
    const {selectedResident: resident, loadResident, loadingInitial, clearSelectedResident} = residentStore;
    const {sid} = useParams<{sid: string}>();

    const villageRulesSegmentRef= useRef<HTMLDivElement>(null);           
    const [enableIAgreeButton, setEnableIAgreeButton] = useState(false);    
  
     // The scroll-to-end listener
    const handleScroll = useCallback(() => {
        if (villageRulesSegmentRef?.current) {            
            const { scrollTop, scrollHeight, clientHeight } = villageRulesSegmentRef.current;
            // console.log('scrolling');
            // Dont need to be exact, just need to be withing 5px
            if (Math.abs((scrollTop + clientHeight) - scrollHeight) <= 5) {
                // TO SOMETHING HERE
                console.log('Reached bottom')
                villageRulesSegmentRef?.current.removeEventListener('scroll', handleScroll);
                console.log('Removed scroll event from handleScroll');
                setEnableIAgreeButton(true);
            }
        }        
    },[]);

    useEffect(() => {  
        const canvasRef = villageRulesSegmentRef.current;               
        function addScrollEventToRulesDiv() {
            villageRulesSegmentRef.current?.addEventListener('scroll', handleScroll);
            console.log('Added scroll event to ' +  canvasRef);
        }        
        addScrollEventToRulesDiv();     
    }, [loadingInitial, villageRulesSegmentRef.current, handleScroll]);

    useEffect(() => {                        
        if (sid) {
            loadResident(sid);
            console.log('Loaded resident ' + resident);
        }
        return () => {
            clearSelectedResident();    
        }
    }, [sid, loadResident, clearSelectedResident]);

    if (loadingInitial) return <LoadingComponent content='Loading resident details...' />;

    if (sid && !resident && !loadingInitial) return <InvalidResident />;

    return (
        <Segment   inverted textAlign='center' vertical className='masthead'>
            <Container text >                              
                <>        
                    <Header as='h2' inverted textAlign='left'>
                        <Image src={BhpLogo} className='logoBrand' /> Village Rules 
                    </Header>     
                   
                    {/* <Header as='h2' textAlign='left' style={{marginBottom: '2px'}}>
                        <Image src={BhpLogo} className='logoBrand' />  
                    </Header>
                    <Header as='h3' textAlign='left' style={{marginTop: '2px', paddingLeft: '20px', color:'black'}}>
                        Village Rules
                    </Header>                    */}
                    
                    {/* <Header as='h2' inverted>
                        BHP Village Rules
                    </Header> */}
                    
                    <div className='ui segment' id='rulesDiv' ref={villageRulesSegmentRef} style={{overflow: 'auto', height: '65vh' }} > 
                        <Container textAlign='left'>                           
                            {ParseHtml((resident?.ruleHtml) ? resident?.ruleHtml : 'Please refresh your browser to reload the rules')}
                        </Container>
                    </div>
                    {!enableIAgreeButton &&
                        <Message warning floating size="mini">
                            {/* <Icon name='warning' /> */}
                            Please read the rules in full to proceed
                      </Message>
                    }
                    {enableIAgreeButton &&
                        <Button onClick={() => modalStore.openModalWithSize(<AgreementForm />, 'small')} size='huge'  inverted>
                             I Agree
                    </Button>   
                    }
                                                     
                </>
                    
            </Container>
        </Segment>    
    )
    
})